import styled, { css } from 'styled-components';
import { isDarkThemeMixin, isNotDarkThemeMixin } from '@amzn/storm-ui';
import { StyledComponentsPropWithTheme } from 'src/commons/components/ChromeApp/ChromeAppUtils';

interface PageHeaderWrapperProps extends StyledComponentsPropWithTheme {
  isMobileDevice: boolean;
  hasSectionNav: boolean;
  isFocusLayout?: boolean;
}

export const PageHeaderWrapper = styled.div<PageHeaderWrapperProps>`
  ${({ theme, isFocusLayout }) => css`
    ${isFocusLayout &&
    css`
      padding-block-start: ${theme.spacing.xxsmall.default};
    `};

    ${isDarkThemeMixin(css`
      background-color: ${isFocusLayout
        ? theme.surface.offsetInverted
        : theme.surface.offset};
    `)};
  `};

  ${({ theme, hasSectionNav }) =>
    hasSectionNav &&
    css`
      border-bottom: 1px solid ${theme.elevation.borderColor.subtle};

      ${isNotDarkThemeMixin(css`
        box-shadow: ${theme.elevation.shadow.card};
      `)};
    `};
`;

export const RodeoContainer = styled.div`
  display: none;
`;
